import Vue from 'vue';

import { BYTES_PER_MEGABYTES } from '@/utils/helpers';

const FILE_SIZE_LIMIT = BYTES_PER_MEGABYTES * 20;

export default Vue.extend({
  name: 'FileUploadRules',

  computed: {
    fileSizeRules() {
      return [
        (file: File) => {
          if (file) {
            const { size = 0 } = file;

            return size <= FILE_SIZE_LIMIT || 'File is too large (limit 20MB)';
          }
          return true;
        }
      ];
    },

    fileUploadRules() {
      return [
        (file: File) => !!file || 'File is required',
        (file: File) => {
          if (file) {
            const { size = 0 } = file;

            return size <= FILE_SIZE_LIMIT || 'File is too large (limit 20MB)';
          }
          return false;
        }
      ];
    },

    multipleFileUploadRules() {
      return [
        (files: File[]) => files.length != 0 || 'A file is required',
        (files: File[]) => {
          if (files) {
            const allFileValid = files.every(
              file => file.size <= FILE_SIZE_LIMIT
            );

            return (
              allFileValid ||
              'A file is too large in the list provided (limit 20MB per file)'
            );
          }
          return false;
        }
      ];
    }
  }
});
